import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue, reduxForm } from 'redux-form';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import {tipoIndicadorContribuicaoIE} from '../../util/constantsUtil';

export class Tomador extends React.Component {
    selecionarTomador(tomador) {

        this.props.changeFieldValue('formularioCadastroTomador',
            'idTomador', tomador.id);
        this.props.changeFieldValue('formularioCadastroTomador',
            'cpf', tomador.cpf);
        this.props.changeFieldValue('formularioCadastroTomador',
            'cnpj', tomador.cnpj);

        if (tomador.tipoTomador === 'PF') {
            this.props.changeFieldValue('formularioCadastroTomador',
                'nomePessoa', tomador.nomePessoa);
            this.props.changeFieldValue('formularioCadastroTomador',
                'numeroDocumento', tomador.numeroDocumento);
            this.props.changeFieldValue('formularioCadastroTomador',
                'dataNascimento', tomador.dataNascimento);
            this.props.changeFieldValue('formularioCadastroTomador',
                'numeroDocumento', tomador.cpf);
        }

        if (tomador.tipoTomador === 'PJ') {
            this.props.changeFieldValue('formularioCadastroTomador',
                'nomeFantasia', tomador.nomeFantasia);
            this.props.changeFieldValue('formularioCadastroTomador',
                'razaoSocial', tomador.razaoSocial);
            this.props.changeFieldValue('formularioCadastroTomador',
                'inscricaoEstadual', tomador.inscricaoEstadual);
            this.props.changeFieldValue('formularioCadastroTomador',
                'inscricaoMunicipal', tomador.inscricaoMunicipal);
            this.props.changeFieldValue('formularioCadastroTomador',
                'numeroCnpj', tomador.cnpj);
        }

        if (tomador.tipoIndicadorContribuicaoIE) {
            const opcaoSelecionada = tipoIndicadorContribuicaoIE.find(it => it.value == tomador.tipoIndicadorContribuicaoIE);
            if (opcaoSelecionada) {
                this.props.changeFieldValue('formularioCadastroTomador',
                    'tipoIndicadorContribuicaoIE', opcaoSelecionada);
            }
        }

        this.props.changeFieldValue('formularioCadastroTomador',
            'cep', tomador.endereco.cep);
        this.props.changeFieldValue('formularioCadastroTomador',
            'idEndereco', tomador.endereco.id);
        this.props.changeFieldValue('formularioCadastroTomador',
            'logradouro', tomador.endereco.logradouro);
        this.props.changeFieldValue('formularioCadastroTomador',
            'complemento', tomador.endereco.complemento);
        this.props.changeFieldValue('formularioCadastroTomador',
            'bairro', tomador.endereco.bairro);
        this.props.changeFieldValue('formularioCadastroTomador',
            'localidade', tomador.endereco.localidade);
        this.props.changeFieldValue('formularioCadastroTomador',
            'uf', tomador.endereco.uf);
        this.props.changeFieldValue('formularioCadastroTomador',
            'numero', tomador.endereco.numero.toString());

        if (tomador.endereco.nomeCidade !== null) {
            const cidadeDeOrigem = {
                id: tomador.endereco.codigoCidade,
                nome: tomador.endereco.nomeCidade,
                uf: tomador.endereco.uf
            };
            this.props.selecionarOrigem(cidadeDeOrigem);
        }
    }

    render() {
        const { tomador } = this.props;
        const nome = tomador.tipoTomador === 'PF' ? tomador.nomePessoa : tomador.nomeFantasia;
        const documento = tomador.tipoTomador === 'PF' ? tomador.cpf : tomador.cnpj;
        return (
            <div className="vx-gp-row">
                <div className="vx-gp-row-main vx-gp-row-main--tomador">
                    <div className="vx-gp-field">
                        <span className="vx-gp-field-label">Nome</span>
                        <span className="vx-gp-field-value">{nome}</span>
                        <span className="vx-gp-field-sub">{tomador.tipoTomador === 'PF' ? 'Pessoa Física' : 'Pessoa Jurídica'}</span>
                    </div>
                    <div className="vx-gp-field">
                        <span className="vx-gp-field-label">CNPJ/CPF</span>
                        <span className="vx-gp-field-value">{documento}</span>
                    </div>
                    <div className="vx-gp-field--actions">
                        <button type="button" className="vx-gp-action-btn mr-2"
                            data-toggle="modal"
                            data-target="#modalCadastrarTomador"
                            title="Editar"
                            onClick={() => this.selecionarTomador(tomador)}>
                            <i className="material-icons" style={{fontSize:18}}>edit</i>
                        </button>
                        <button type="button" className="vx-gp-action-btn"
                            data-toggle="modal"
                            data-target="#modalConfirmacaoExclusaoTomador"
                            title="Excluir"
                            style={{color:'#dc2626', borderColor:'#fee2e2'}}
                            onClick={() => this.props.selecionarTomador(tomador)}>
                            <i className="material-icons" style={{fontSize:18}}>delete</i>
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps() {
    return {}
}

export default connect(mapStateToProps, {
    changeFieldValue,
    selecionarOrigem
})(reduxForm({
    form: 'formularioCadastroTomador'
})(Tomador))
